import { Button } from '@cluey/cluey-components';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router';

import { ShadowContainer } from '../../../../../components/ShadowContainer';
import { StudentInformationForm } from '../../../../../components/hub/student/StudentInformationForm';
import { ChevronDownIcon } from '../../../../../icons';
import { FormFlowProps } from '../../../../../types/hubInterfaces';
import { PATH_HUB_HOME } from '../../../../../util/pagePath';
import { usePageHeader } from '../../../../../v2/app-shell/usePageHeader';
import { StudentProfileData } from '../../StudentProfile/StudentProfile';

interface Props {
  formFlowProps: FormFlowProps;
}

const AddStudentInformation = ({ formFlowProps }: Props) => {
  const formUtils = useFormContext();
  const history = useHistory<StudentProfileData>();
  const historyState = history.location.state;

  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: 'Students',
      showIcon: false,
      showBackButton: true,
    });
  }, [setHeader]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const onNext = async () => {
    const formValid = await formUtils.trigger();
    if (formValid) {
      formFlowProps.next({ ...historyState, ...formUtils.getValues() });
    }
  };

  return (
    <div className="container">
      <ShadowContainer className="flex flex-col gap-4 !rounded-3xl bg-white p-6 md:!p-10">
        <h1 className="font-bold md:text-2xl">Add a new student</h1>
        <p className="text-lg text-grey-600">
          Before we find the right program, please tell us a bit about about the student:
        </p>
        <StudentInformationForm formUtils={formUtils} />
        <div className="flex flex-col gap-4 pt-3 md:flex-row md:justify-start">
          <Button onClick={onNext} className="flex h-10 items-center justify-center gap-3 normal-case" size="sm">
            <span className="text-base font-medium tracking-wide text-white">Next</span>
            <ChevronDownIcon className="rotate-[-90deg] text-white" />
          </Button>
          <Button
            onClick={() => {
              history.push(PATH_HUB_HOME);
            }}
            className="flex h-10 items-center justify-center !border normal-case"
            size="sm"
            appearance="reverse"
          >
            <span className="text-base font-medium tracking-wide text-grey-400">Cancel</span>
          </Button>
        </div>
      </ShadowContainer>
    </div>
  );
};

export { AddStudentInformation };
